export const styles = {
  tabs: {
    marginTop: "32px",
    "& .MuiTabs-indicator": {
      backgroundColor: "events.bluePrimary",
      height: "4px",
    },
    "& .MuiTabs-flexContainer": {
      boxSizing: "border-box",
      borderWidth: "0 0 4px 0",
      borderStyle: "solid",
      borderColor: "events.grayShade1",
    },
  },
  tab: {
    "&.Mui-selected": {
      color: "events.bluePrimary",
    },
    fontSize: "14px",
  },
};
